var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.56,
    height: 77.519,
    viewBox: "0 0 84.56 77.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_837",
    "data-name": "Trac\\xE9 837",
    d: "M-12.355,267.385H58.527v44.59a2.465,2.465,0,0,1-2.465,2.465H-8.966a3.389,3.389,0,0,1-3.389-3.389V267.385Z",
    transform: "translate(12.355 -267.385)",
    fill: "#d3d5e7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_838",
    "data-name": "Trac\\xE9 838",
    d: "M-40.2,247.338H30.683v44.589a2.465,2.465,0,0,1-2.465,2.465H-36.811A3.389,3.389,0,0,1-40.2,291Z",
    transform: "translate(40.2 -247.338)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1685",
    "data-name": "Groupe 1685",
    transform: "translate(59.956 -183.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1",
    transform: "translate(-54.66 187.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-1-copy-21",
    d: "M47.152,208a4.28,4.28,0,0,0-4.278-4.278H-27.834A4.28,4.28,0,0,0-32.112,208v54.532a4.28,4.28,0,0,0,4.278,4.278H42.874a4.28,4.28,0,0,0,4.278-4.278Z",
    transform: "translate(32.112 -203.724)",
    fill: "#d3d5e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1681",
    "data-name": "Groupe 1681",
    transform: "translate(3.758 12.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1680",
    "data-name": "Groupe 1680",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1679",
    "data-name": "Groupe 1679",
    transform: "translate(5.862 3.414)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1-copy1",
    width: 56.964,
    height: 11.814,
    transform: "translate(0)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-copy-51",
    width: 18.208,
    height: 9.831,
    transform: "translate(0.453 14.26)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-copy-41",
    width: 38.409,
    height: 11.978,
    transform: "translate(0.453 28.077)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-copy-31",
    width: 15.647,
    height: 11.978,
    transform: "translate(41.173 28.077)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-copy1",
    width: 15.791,
    height: 3.524,
    transform: "translate(21.289 14.328)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-copy1",
    width: 35.848,
    height: 3.774,
    transform: "translate(21.154 20.365)",
    fill: "#d3d5e7"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-1-copy-51",
    cx: 2.017,
    cy: 2.017,
    r: 2.017,
    transform: "translate(11.102 3.784)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-1-copy-41",
    cx: 2.017,
    cy: 2.017,
    r: 2.017,
    transform: "translate(5.296 3.784)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-1-copy-31",
    cx: 2.017,
    cy: 2.017,
    r: 2.017,
    transform: "translate(16.898 3.784)",
    fill: "#d3d5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-3-copy1",
    d: "M197.1,225.625a1.855,1.855,0,0,0-1.854-1.854h-19.4a1.855,1.855,0,0,0-1.854,1.854v.3a1.854,1.854,0,0,0,1.854,1.854h19.4a1.854,1.854,0,0,0,1.854-1.854Z",
    transform: "translate(-134.791 -219.958)",
    fill: "#d3d5e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-3-copy-31",
    d: "M336.126,225.487a1.868,1.868,0,0,0-1.867-1.867h-2.573a1.868,1.868,0,0,0-1.867,1.867v.3a1.868,1.868,0,0,0,1.867,1.867h2.573a1.868,1.868,0,0,0,1.867-1.867Z",
    transform: "translate(-260.983 -219.836)",
    fill: "#d3d5e7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-1",
    d: "M19.308,187.954a4.28,4.28,0,0,0-4.278-4.278H-55.678a4.28,4.28,0,0,0-4.278,4.278v54.532a4.28,4.28,0,0,0,4.278,4.278H15.03a4.28,4.28,0,0,0,4.278-4.278Z",
    fill: "#15144b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-2",
    d: "M-40.2,247.338H30.683v44.589a2.465,2.465,0,0,1-2.465,2.465H-36.811A3.389,3.389,0,0,1-40.2,291Z",
    transform: "translate(-15.999 -51.554)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1684",
    "data-name": "Groupe 1684",
    transform: "translate(-56.199 195.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1683",
    "data-name": "Groupe 1683",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1682",
    "data-name": "Groupe 1682",
    transform: "translate(3.193 3.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1",
    d: "M1-.5H62.885a1.5,1.5,0,0,1,1.5,1.5v9.814a1.5,1.5,0,0,1-1.5,1.5H1a1.5,1.5,0,0,1-1.5-1.5V1A1.5,1.5,0,0,1,1-.5ZM62.885,11.314a.5.5,0,0,0,.5-.5V1a.5.5,0,0,0-.5-.5H1A.5.5,0,0,0,.5,1v9.814a.5.5,0,0,0,.5.5Z",
    fill: "#15144b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    d: "M1-.5H19.984a1.5,1.5,0,0,1,1.5,1.5V8.831a1.5,1.5,0,0,1-1.5,1.5H1a1.5,1.5,0,0,1-1.5-1.5V1A1.5,1.5,0,0,1,1-.5ZM19.984,9.331a.5.5,0,0,0,.5-.5V1a.5.5,0,0,0-.5-.5H1A.5.5,0,0,0,.5,1V8.831a.5.5,0,0,0,.5.5Z",
    transform: "translate(0.522 14.26)",
    fill: "#15144b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2-copy",
    d: "M1-.5H43.266a1.5,1.5,0,0,1,1.5,1.5v9.978a1.5,1.5,0,0,1-1.5,1.5H1a1.5,1.5,0,0,1-1.5-1.5V1A1.5,1.5,0,0,1,1-.5ZM43.266,11.478a.5.5,0,0,0,.5-.5V1a.5.5,0,0,0-.5-.5H1A.5.5,0,0,0,.5,1v9.978a.5.5,0,0,0,.5.5Z",
    transform: "translate(0.522 28.077)",
    fill: "#15144b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2-copy-2",
    d: "M-.5-.5H18.532V12.478H-.5ZM17.532.5H.5V11.478H17.532Z",
    transform: "translate(45.686 28.077)",
    fill: "#15144b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3",
    d: "M1-.5H16.207a1.5,1.5,0,0,1,1.5,1.5V2.524a1.5,1.5,0,0,1-1.5,1.5H1a1.5,1.5,0,0,1-1.5-1.5V1A1.5,1.5,0,0,1,1-.5ZM16.207,3.024a.5.5,0,0,0,.5-.5V1a.5.5,0,0,0-.5-.5H1A.5.5,0,0,0,.5,1V2.524a.5.5,0,0,0,.5.5Z",
    transform: "translate(24.616 14.327)",
    fill: "#15144b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-4",
    d: "M1-.5H38.314a1.5,1.5,0,0,1,1.5,1.5V2.774a1.5,1.5,0,0,1-1.5,1.5H1a1.5,1.5,0,0,1-1.5-1.5V1A1.5,1.5,0,0,1,1-.5ZM38.314,3.274a.5.5,0,0,0,.5-.5V1a.5.5,0,0,0-.5-.5H1A.5.5,0,0,0,.5,1V2.774a.5.5,0,0,0,.5.5Z",
    transform: "translate(24.616 20.365)",
    fill: "#15144b"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-1",
    cx: 2.017,
    cy: 2.017,
    r: 2.017,
    transform: "translate(-48.854 187.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-1-copy",
    cx: 2.017,
    cy: 2.017,
    r: 2.017,
    transform: "translate(-54.66 187.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse-1-copy-2",
    cx: 2.017,
    cy: 2.017,
    r: 2.017,
    transform: "translate(-43.058 187.46)",
    fill: "#50dbb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-3",
    d: "M169.255,205.578a1.855,1.855,0,0,0-1.854-1.854H148a1.854,1.854,0,0,0-1.854,1.854v.3A1.854,1.854,0,0,0,148,207.73h19.4a1.855,1.855,0,0,0,1.854-1.854Z",
    transform: "translate(-166.903 -16.235)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded-Rectangle-3-copy-2",
    d: "M308.281,205.439a1.868,1.868,0,0,0-1.867-1.868h-2.572a1.868,1.868,0,0,0-1.867,1.868v.3a1.869,1.869,0,0,0,1.867,1.868h2.572a1.868,1.868,0,0,0,1.867-1.868Z",
    transform: "translate(-293.094 -16.112)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-1-copy-2",
    d: "M182.366,425.806a2.041,2.041,0,0,0-1.748.851,1.113,1.113,0,0,0,.095,1.158,48.354,48.354,0,0,1,2.526,5.424A59.434,59.434,0,0,0,186.42,440c1.665,2.921,2.5,4.55,2.9,5.37l12.064,0c.365-.668,1.055-1.879,2.382-4.179a19.888,19.888,0,0,0,2.569-9.44l-.01-4.558c0-.034,0-.067,0-.1.007-.09.158-2.319-1.406-2.674a1.621,1.621,0,0,0-.356-.043c-.179,0-.72,0-1.011,1.149-.053.377-.109.613-.109.613a1.105,1.105,0,0,1-2.177-.352,4.892,4.892,0,0,1,.11-.677,3.55,3.55,0,0,0-.386-2.488,1.377,1.377,0,0,0-1.085-.482c-.888-.061-1.5.1-1.615,1.243l.043,1.087a1.117,1.117,0,0,1-.976,1.162,1.1,1.1,0,0,1-1.214-.9,5.8,5.8,0,0,1-.07-1.4l-.028-.7a1.156,1.156,0,0,1,.033-.322,1.936,1.936,0,0,0-.208-1.366,2.051,2.051,0,0,0-1.563-.525h0c-.705,0-1.356.176-1.573,1.427l.061,2.232a1.119,1.119,0,0,1-.974,1.149,1.1,1.1,0,0,1-1.213-.885,8.832,8.832,0,0,1-.09-2.637l-.216-7.937a.949.949,0,0,1,0-.107,2.469,2.469,0,0,0-.454-1.57,1.263,1.263,0,0,0-.967-.358c-1.573,0-1.664,1.825-1.67,2.033l-.16,13.689a1.122,1.122,0,0,1-.91,1.095,1.109,1.109,0,0,1-1.228-.7,2.726,2.726,0,0,0-2.551-2.037Z",
    transform: "translate(-194.72 -184.678)",
    fill: "#4f0dbc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-1-copy-2_-_Contour",
    "data-name": "Shape-1-copy-2 - Contour",
    d: "M188.885,411.227h.006a1.755,1.755,0,0,1,1.329.52,2.988,2.988,0,0,1,.586,1.935v.006a.466.466,0,0,0,0,.051v.01l.217,7.977-.005.039a8.4,8.4,0,0,0,.084,2.471h0a.607.607,0,0,0,.578.494.569.569,0,0,0,.077-.005h.008a.616.616,0,0,0,.535-.639l-.062-2.282.009-.049a1.9,1.9,0,0,1,2.066-1.842h.006a1.938,1.938,0,0,1,2.255,2.494l0,.015a.657.657,0,0,0-.019.183l.029.731,0,.027a5.272,5.272,0,0,0,.062,1.27.6.6,0,0,0,.578.507.551.551,0,0,0,.076-.005h.011a.619.619,0,0,0,.534-.645l-.045-1.123,0-.036a1.652,1.652,0,0,1,1.815-1.7c.1,0,.211,0,.332.012a1.9,1.9,0,0,1,1.442.67,3.966,3.966,0,0,1,.492,2.86l0,.025-.006.025a4.413,4.413,0,0,0-.1.6.617.617,0,0,0,.51.666.582.582,0,0,0,.091.007.614.614,0,0,0,.592-.477s.052-.219.1-.564l0-.027.007-.026c.252-1,.769-1.527,1.5-1.527a2.114,2.114,0,0,1,.467.056c1.576.357,1.869,2.179,1.793,3.2,0,.027,0,.046,0,.064l.01,4.553a20.559,20.559,0,0,1-2.636,9.695c-1.291,2.238-2,3.484-2.376,4.169l-.142.26-12.673,0-.137-.282c-.415-.857-1.253-2.479-2.885-5.341a59.72,59.72,0,0,1-3.2-6.8l-.01-.023a47.9,47.9,0,0,0-2.494-5.357,1.592,1.592,0,0,1-.1-1.652,2.519,2.519,0,0,1,2.184-1.106,3.2,3.2,0,0,1,3.018,2.359.613.613,0,0,0,.569.4.6.6,0,0,0,.1-.009.622.622,0,0,0,.5-.609l.16-13.7A2.305,2.305,0,0,1,188.885,411.227Zm.922,2.4a2,2,0,0,0-.324-1.2c-.043-.046-.175-.19-.6-.2-1.062,0-1.159,1.276-1.167,1.544l-.16,13.685a1.6,1.6,0,0,1-3.105.565,2.23,2.23,0,0,0-2.083-1.714,1.578,1.578,0,0,0-1.313.6c-.042.075-.142.253.093.664a48.617,48.617,0,0,1,2.55,5.47l.01.023a58.933,58.933,0,0,0,3.148,6.695c1.483,2.6,2.318,4.192,2.778,5.118l11.457,0c.406-.731,1.1-1.941,2.244-3.929a19.529,19.529,0,0,0,2.5-9.177v-.012l-.01-4.558c0-.046,0-.09.006-.142,0-.016.126-1.888-1.018-2.147a1.136,1.136,0,0,0-.245-.031.234.234,0,0,0-.166.045,1.241,1.241,0,0,0-.353.7c-.054.38-.112.621-.114.632a1.612,1.612,0,0,1-1.564,1.242,1.6,1.6,0,0,1-.251-.02,1.611,1.611,0,0,1-1.347-1.728,5.3,5.3,0,0,1,.115-.724,3.078,3.078,0,0,0-.283-2.089c-.062-.078-.206-.259-.731-.3-.1-.007-.183-.01-.262-.01-.492,0-.736.077-.816.772l.042,1.05a1.624,1.624,0,0,1-1.412,1.678,1.558,1.558,0,0,1-.209.014,1.6,1.6,0,0,1-1.559-1.316,6.268,6.268,0,0,1-.079-1.5l-.027-.677a1.654,1.654,0,0,1,.045-.45,1.429,1.429,0,0,0-.116-.953,1.621,1.621,0,0,0-1.169-.329c-.536,0-.9.07-1.07.965l.059,2.18a1.611,1.611,0,0,1-1.41,1.659,1.576,1.576,0,0,1-.209.014,1.611,1.611,0,0,1-1.558-1.292v-.006a9.347,9.347,0,0,1-.1-2.758l-.215-7.894A1.445,1.445,0,0,1,189.807,413.627Z",
    transform: "translate(-194.72 -184.678)",
    fill: "#15144b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-1-copy",
    d: "M181.375,423.1a1.734,1.734,0,0,0-1.483.719.938.938,0,0,0,.08.979,40.734,40.734,0,0,1,2.143,4.582,50.072,50.072,0,0,0,2.7,5.713c1.413,2.467,2.123,3.844,2.46,4.537l10.232,0c.31-.564.895-1.588,2.02-3.531a16.746,16.746,0,0,0,2.179-7.975l-.009-3.851c0-.029,0-.057,0-.085.006-.076.134-1.96-1.192-2.259a1.384,1.384,0,0,0-.3-.036c-.152,0-.611,0-.857.971-.045.319-.093.517-.093.517a.937.937,0,0,1-1.847-.3,4.088,4.088,0,0,1,.093-.572,2.988,2.988,0,0,0-.328-2.1,1.167,1.167,0,0,0-.921-.408c-.754-.052-1.269.082-1.37,1.05l.037.918a.945.945,0,0,1-.828.982.931.931,0,0,1-1.03-.761,4.884,4.884,0,0,1-.059-1.184l-.024-.594a.968.968,0,0,1,.028-.272,1.628,1.628,0,0,0-.176-1.154,1.743,1.743,0,0,0-1.326-.444h0c-.6,0-1.15.149-1.334,1.206l.052,1.886a.946.946,0,0,1-.827.971.931.931,0,0,1-1.029-.747,7.435,7.435,0,0,1-.076-2.228l-.183-6.706a.873.873,0,0,1,0-.09,2.078,2.078,0,0,0-.385-1.326,1.072,1.072,0,0,0-.82-.3c-1.335,0-1.412,1.542-1.417,1.717l-.136,11.565a.936.936,0,0,1-1.813.332,2.312,2.312,0,0,0-2.163-1.721Z",
    transform: "translate(-194.147 -184.26)",
    fill: "#50dbb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-1",
    d: "M178.7,433.438a.937.937,0,0,1-.868-.59c-.01-.025-.5-1.183-2.62-4.894a52.4,52.4,0,0,1-2.8-5.924,39.2,39.2,0,0,0-2.036-4.366,2.849,2.849,0,0,1-.088-2.884,3.567,3.567,0,0,1,3.11-1.674,3.869,3.869,0,0,1,2.132.626l.106-8.938c.033-1.248.755-3.583,3.262-3.583a2.951,2.951,0,0,1,2.233.921,3.962,3.962,0,0,1,.878,2.684l.109,4a3.89,3.89,0,0,1,4.229.92,2.731,2.731,0,0,1,.321.54,3.476,3.476,0,0,1,1.742-.268,3.065,3.065,0,0,1,2.243,1.1,3.311,3.311,0,0,1,.54,1,2.741,2.741,0,0,1,1.747-.134c2.317.523,2.751,2.971,2.656,4.235L195.6,420a18.524,18.524,0,0,1-2.436,8.967c-1.735,3-2.117,3.7-2.2,3.862a.953.953,0,0,1-.153.265.937.937,0,0,1-.779.343l-11.335,0Zm-5.3-18.431a1.734,1.734,0,0,0-1.483.719.938.938,0,0,0,.08.979,40.7,40.7,0,0,1,2.143,4.582,50.074,50.074,0,0,0,2.7,5.713c1.413,2.467,2.123,3.845,2.46,4.537l10.232,0c.31-.564.895-1.588,2.02-3.531a16.743,16.743,0,0,0,2.179-7.975l-.009-3.851c0-.029,0-.057,0-.085.006-.076.134-1.96-1.192-2.259a1.387,1.387,0,0,0-.3-.036c-.152,0-.611,0-.857.971-.045.319-.093.517-.093.517a.938.938,0,0,1-1.847-.3,4.134,4.134,0,0,1,.094-.572,2.988,2.988,0,0,0-.328-2.1,1.167,1.167,0,0,0-.921-.408c-.754-.052-1.269.082-1.37,1.05l.037.918a.945.945,0,0,1-.828.982.931.931,0,0,1-1.03-.761,4.884,4.884,0,0,1-.059-1.184l-.024-.594a.968.968,0,0,1,.028-.272,1.629,1.629,0,0,0-.176-1.154,1.743,1.743,0,0,0-1.326-.443h0c-.6,0-1.15.149-1.334,1.206l.052,1.886a.946.946,0,0,1-.827.971.931.931,0,0,1-1.029-.747,7.436,7.436,0,0,1-.076-2.228l-.183-6.706a.878.878,0,0,1,0-.09,2.079,2.079,0,0,0-.385-1.326,1.072,1.072,0,0,0-.82-.3c-1.335,0-1.412,1.542-1.417,1.717l-.136,11.565a.937.937,0,0,1-1.813.332,2.312,2.312,0,0,0-2.163-1.721Z",
    transform: "translate(-186.169 -176.162)",
    fill: "#15144b",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriving);
export default __webpack_public_path__ + "static/media/driving.1d7186c8dc9ee3c6511f7108fab55653.svg";
export { ForwardRef as ReactComponent };